import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function ChainLogo(props: SvgIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M10.7586 8.4966C11.2346 8.22602 11.2346 7.78117 10.7586 7.5106L6.93115 5.3368C6.45506 5.06623 6.06299 5.28636 6.06299 5.82751V10.1705C6.06299 10.7117 6.45506 10.9364 6.93115 10.6612L10.7586 8.48743V8.4966Z"
        fill="#0C7FA4"
      />
      <path
        d="M7.98131 0C3.63084 0 0 3.02239 0 7.78105C0 8.93397 0.214954 9.98584 0.602804 10.9229C0.985982 11.8553 2.23832 12.0804 2.96262 11.3684L3.00467 11.3271C3.41589 10.9229 3.53738 10.3166 3.32243 9.78373C3.08411 9.1866 2.9486 8.51598 2.9486 7.78105C2.9486 4.75866 5.23832 2.86163 7.98598 2.86163C10.7336 2.86163 13.0234 4.75866 13.0234 7.78105C13.0234 10.8034 10.7336 12.8291 7.98598 12.8291C7.28505 12.8291 6.61682 12.7005 6.00467 12.457C5.46262 12.2411 4.84112 12.356 4.42523 12.7648C3.6729 13.5043 3.96262 14.7399 4.95327 15.1166C5.89252 15.4748 6.91589 15.6632 7.98598 15.6632C12.3365 15.6632 16 12.5443 16 7.78565C16 3.02699 12.3365 0.00459341 7.98598 0.00459341L7.98131 0Z"
        fill="#494E56"
      />
    </SvgIcon>
  );
}
